module.exports = __webpack_public_path__ + "images/06c5e682265ee8d0dba614c3ebe734ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/scenes/Shell/scenes/Header/img/Free_Spirit_BO_B2C.png
// module id = 570
// module chunks = 0